import { Button, Grid, Typography } from '@mui/material';
import { ComponentType, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../base-dialog';

export interface ConfirmDialogProps {
  title?: string;
  text?: ReactNode;
  positive?: string;
  negative?: string;
  resolve?: () => void;
  reject?: () => void;
  variant?: 'success' | 'info' | 'warning' | 'error';
  popDialog?: any;
}

export const ConfirmDialog: ComponentType<ConfirmDialogProps> = ({
  title,
  text,
  positive,
  negative,
  resolve,
  reject,
  variant = 'error',
  popDialog,
  ...props
}) => {
  const { t } = useTranslation();

  const dialogTitle = title ? title : t('confirmation', 'Подтверждение');
  const dialogPositive = positive ? positive : t('ok', 'Ок');
  const dialogNegative = negative ? negative : t('cancel', 'Отмена');
  const dialogText = text ? text : t('areYouSure', 'Вы уверены?');

  const handleReject = () => {
    if (reject) reject();
    if (popDialog) popDialog();
  };

  const handleResolve = () => {
    if (resolve) resolve();
  };

  return (
    <BaseDialog {...{ ...props, popDialog: handleReject }} title={dialogTitle}>
      <Typography variant="h5" component="p" mb={4}>
        {dialogText}
      </Typography>
      <Grid container columnSpacing={2} justifyContent="flex-end">
        <Grid item xs={6}>
          <Button
            onClick={handleReject}
            variant="outlined"
            size="large"
            fullWidth
            sx={{ minWidth: 0, whiteSpace: 'nowrap' }}
          >
            {dialogNegative}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            onClick={handleResolve}
            variant="contained"
            color={variant}
            size="large"
            fullWidth
            sx={{ minWidth: 0, whiteSpace: 'nowrap' }}
          >
            {dialogPositive}
          </Button>
        </Grid>
      </Grid>
    </BaseDialog>
  );
};
